import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import { BarChart } from '@mui/x-charts/BarChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import HeaderMMS from './header/header';
import MenuMMS from './menu/menu';
import './workorder/workorder.css';
import {
  GaugeContainer,
  GaugeValueArc,
  GaugeReferenceArc,
  useGaugeState,
} from '@mui/x-charts/Gauge';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
} from "chart.js";
import { Bar, Line, Pie,Doughnut, PolarArea, Radar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend
);

const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"];

  // Bar Chart Data
  const barData = {
    labels,
    datasets: [
      {
        label: "Sales",
        data: [120, 200, 150, 300, 250, 400, 350],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "Sales1",
        data: [220, 100, 50, 200, 240, 400, 350],
        backgroundColor: "rgba(133, 26, 200, 0.6)",
      },
    ],
  };

  // Line Chart Data
  const lineData = {
    labels,
    datasets: [
      {
        label: "Revenue",
        data: [100, 150, 200, 180, 220, 300, 280],
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: "rgba(54, 162, 235, 0.3)",
        tension: 0.4,
        fill: true,
      },
      {
        label: "Revenue2",
        data: [10, 110, 300, 180, 320, 300, 180],
        borderColor: "rgba(217, 74, 18, 1)",
        backgroundColor: "rgba(180, 243, 9, 0.3)",
        tension: 0.4,
        fill: true,
      },
    ],
  };

  // Pie Chart Data
  const pieData = {
    labels: ["Electronics", "Clothing", "Groceries", "Others"],
    datasets: [
      {
        label: "Category Share",
        data: [40, 25, 20, 15],
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
  };

  // Doughnut chart data
const doughnutData = {
  labels: ["Red", "Blue", "Yellow"],
  datasets: [
    {
      label: "Votes",
      data: [12, 19, 3],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
      borderWidth: 1
    }
  ]
};

// Polar area chart data
const polarData = {
  labels: ["Red", "Green", "Yellow", "Grey", "Blue"],
  datasets: [
    {
      label: "My Dataset",
      data: [11, 16, 7, 3, 14],
      backgroundColor: [
        "#FF6384",
        "#4BC0C0",
        "#FFCE56",
        "#E7E9ED",
        "#36A2EB"
      ]
    }
  ]
};

// Radar chart data
const radarData = {
  labels: ["Eating", "Drinking", "Sleeping", "Designing", "Coding", "Cycling", "Running"],
  datasets: [
    {
      label: "Person A",
      data: [65, 59, 90, 81, 56, 55, 40],
      backgroundColor: "rgba(179,181,198,0.2)",
      borderColor: "rgba(179,181,198,1)",
      pointBackgroundColor: "rgba(179,181,198,1)"
    },
    {
      label: "Person B",
      data: [28, 48, 40, 19, 96, 27, 100],
      backgroundColor: "rgba(255,99,132,0.2)",
      borderColor: "rgba(255,99,132,1)",
      pointBackgroundColor: "rgba(255,99,132,1)"
    }
  ]
};
const settings = {
  width: 200,
  height: 200,
  value: 60,
};

const additionalData = [
  { label: 'Total', value: 400 },
  { label: 'In Warrenty', value: 300 },
  { label: 'Out of warrenty', value: 300 },
  { label: 'Soon to expire', value: 200 },
];

const dataTasks = [
  { label: 'Total Task', value: 400 },
  { label: 'Completed Task', value: 300 },
  { label: 'Pending Task', value: 300 },
];



const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
const xLabels = [
  'Page A',
  'Page B',
  'Page C',
  'Page D',
  'Page E',
  'Page F',
  'Page G',
];

const warantySize = {
  width: 650,
  height: 400,
};

const orderSize = {
  width: 700,
  height: 450,
};

function GaugePointer() {
  const { valueAngle, outerRadius, cx, cy } = useGaugeState();

  if (valueAngle === null) {
    // No value to display
    return null;
  }

  const target = {
    x: cx + outerRadius * Math.sin(valueAngle),
    y: cy - outerRadius * Math.cos(valueAngle),
  };
  return (
    <g>
      <circle cx={cx} cy={cy} r={5} fill="red" />
      <path
        d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
        stroke="red"
        strokeWidth={3}
      />
    </g>
  );
}
export default function MiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const headerProps = {
    open,
    handleDrawerOpen,
  };

  const menuProps = {
    setOpen,
    open,
  };
  const data2 = [
    { label: 'Total PM order', value: 2400 },
    { label: 'Completed PM order', value: 4567 },
    { label: 'Due PM orders ', value: 1398 },
    { label: 'Soon to Due PM orders', value: 9800 },
    { label: 'Over Due PM Orders', value: 3908 },
  ];
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <HeaderMMS {...headerProps} />
      <MenuMMS {...menuProps} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} className="bg-slate-100 overflow-hidden">
        <Grid className="bg-slate-100">
          <DrawerHeader />
          <div className="rounded p-3 text-lg text-left font-semibold">
            <h2>Dashboard</h2>
          </div>
          <div className="">
            <div className="text-left bg-white p-3 m-2 border-solid border rounded">
              <div className="border-slate-300 rounded-md">
                <h3 className="border-b-2 p-3">Work Order</h3>
              </div>
              <div className="m-5 flex mb-2">
                <div className="text-center pt-2">
                  <Grid container xs={12} md={12} spacing={2} rowSpacing={1}>
                  <Grid md={6} xs={12} item>
 <Bar data={barData} options={options} />
                  </Grid>
                  <Grid md={6} xs={12} item>
<Line data={lineData} options={options} />
                  </Grid>
                  <Grid md={6} xs={12} item>
 <Pie data={pieData} options={options} />
                  </Grid>
                  <Grid md={6} xs={12} item>
 <Doughnut data={doughnutData} />
                  </Grid>
                  <Grid md={6} xs={12} item>
<PolarArea data={polarData} />
                  </Grid>
                  <Grid md={6} xs={12} item>
<Radar data={radarData} />
                  </Grid>
                  </Grid>
                  
                   
                     
                     
                  <BarChart
                    xAxis={[
                      {
                        scaleType: 'band',
                        data: [
                          'Total Work orders',
                          'Open orders',
                          'Completed order',
                          'Pending orders',
                        ],
                      },
                    ]}
                    series={[
                      { data: [4, 3, 5, 3] },
                      { data: [1, 6, 3, 9] },
                      { data: [2, 5, 6, 1] },
                      { data: [2, 5, 6, 7] },
                    ]}
                    width={600}
                    height={200}
                  />
                  {/* <Gauge width={200} height={200} value={60} startAngle={-90} endAngle={90} /> */}
                  
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="text-left bg-white p-3 m-2 border-solid border rounded ">
              <div className="border-slate-300 rounded-md">
                <h3 className="border-b-2 p-3">PM Work Order</h3>
              </div>
              <div className="m-5 flex mb-2">
                <div className="w-1/2 pt-2">
                <Gauge width={300} height={300} value={50} valueMin={10} valueMax={60} />
                </div>
                <div className="w-1/2 pt-2"></div>
              </div>
            </div>
            <div className="text-left bg-white p-3 m-2 border-solid border rounded ">
              <div className="border-slate-300 rounded-md">
                <h3 className="border-b-2 p-3">Warranty Manager</h3>
              </div>
              <div className="w-1/2 pt-2">
              <Gauge
  {...settings}
  cornerRadius="50%"
  sx={(theme) => ({
    [`& .${gaugeClasses.valueText}`]: {
      fontSize: 40,
    },
    [`& .${gaugeClasses.valueArc}`]: {
      fill: '#52b202',
    },
    [`& .${gaugeClasses.referenceArc}`]: {
      fill: theme.palette.text.disabled,
    },
  })}
/>
              <PieChart
                    series={[
                      {
                        arcLabel: (item) => `${item.label} (${item.value})`,
                        arcLabelMinAngle: 45,
                        data: additionalData,
                      },
                    ]}
                    sx={{
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: 'white',
                        fontWeight: 'bold',
                      },
                    }}
                    {...orderSize}
                  />
                  
              </div>
            </div>
          </div>
          <div className="">
            <div className="text-left bg-white p-3 m-2 border-solid border rounded">
              <div className="border-slate-300 rounded-md">
                <h3 className="border-b-2 p-3">Task</h3>
              </div>
              <div className="m-5 flex mb-2">
                <div className="pt-2">
                
                  <GaugeContainer
  width={200}
  height={200}
  startAngle={-110}
  endAngle={110}
  value={30}
>
  <GaugeReferenceArc />
  <GaugeValueArc />
  <GaugePointer />
</GaugeContainer>
                </div>
              </div>
            </div>
           
          </div>
        </Grid>
      </Box>
    </Box>
  );
}

